/** @jsxImportSource @emotion/react */

import UI from "@mile-meeting/mile-ui";
import { css } from "@emotion/react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const SlackRedirect = () => {
  const location = useLocation();
  const page = location.pathname.split("/")[3];
  const queryParams = new URLSearchParams(location.search);

  const getSlackBotToken = async () => {
    const code = queryParams.get("code");
    const state = queryParams.get("state");

    const result = await fetch(`${process.env.REACT_APP_SLACK_API_URL}/auth/info?code=${code}&state=${state}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });
    const { botToken, userId, teamName, workspaceId } = await result.json();

    try {
      if (window.opener) {
        if (botToken) {
          window.opener.postMessage({ success: true, botToken, userId, teamName, workspaceId }, "*");
        } else {
          window.opener.postMessage({ success: false }, "*");
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      window.close();
    }
  };

  useEffect(() => {
    if (page.includes("callback")) {
      getSlackBotToken();
    }
  }, []);

  return (
    <div
      css={css`
        background-color: #d1d1d1;
        display: flex;
        width: 100%;
        height: 100vh;
      `}
    >
      <div
        css={css`
          width: max-content;
          height: max-content;
          margin: auto;
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
          animation: spin 2s linear infinite;
        `}
      >
        <UI.Icon name="change" color="white" size={50} />
      </div>
    </div>
  );
};

export default SlackRedirect;
